import React from 'react';
import type { ColDef, EditableCallbackParams } from 'ag-grid-community';
import { LopCrudPage } from '../../components/LopCrudPage';
import {
  getBenchmarkRatePeriods,
  saveBenchmarkRatePeriodsBatch,
} from '../../api/benchmarkRatePeriods';
import type { BenchmarkRatePeriod } from '../../types/BenchmarkRatePeriod';
import { t } from '../../i18n/t';

const benchmarkRatePeriodsColumnDefs: ColDef<BenchmarkRatePeriod>[] = [
  {
    field: 'benchmarkRatePeriodId',
    headerName: t('benchmarkRatePeriods.columns.benchmarkRatePeriodId'),
    width: 120,
    // Natural PK: editable on Add only; existing rows must keep their id.
    editable: (params: EditableCallbackParams<BenchmarkRatePeriod>) =>
      (params.data as { __status?: string } | undefined)?.__status === 'added',
    cellDataType: 'number',
    sort: 'asc',
  },
  {
    field: 'benchmarkRatePeriodName',
    headerName: t('benchmarkRatePeriods.columns.benchmarkRatePeriodName'),
    flex: 1,
    editable: true,
  },
];

const newBenchmarkRatePeriodDefaults = (): Partial<BenchmarkRatePeriod> => ({
  benchmarkRatePeriodId: 0,
  benchmarkRatePeriodName: '',
});

export function BenchmarkRatePeriodsPage() {
  return (
    <LopCrudPage<BenchmarkRatePeriod>
      resourceCode="benchmarkRatePeriods"
      titleKey="benchmarkRatePeriods.pageTitle"
      idField="benchmarkRatePeriodId"
      getRows={getBenchmarkRatePeriods}
      saveBatch={(added, modified, deletedIds) =>
        saveBenchmarkRatePeriodsBatch(added, modified, deletedIds as number[])
      }
      columnDefs={benchmarkRatePeriodsColumnDefs}
      newRowDefaults={newBenchmarkRatePeriodDefaults}
    />
  );
}
